import { createUseStyles } from 'react-jss'

const useInfoBoxStyles = createUseStyles(() => ({
  infoBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    borderRadius: '4px',
    color: '#0D47A1',
    backgroundColor: '#BBDEFB',
    border: '1px solid #64B5F6',
    padding: '0.75rem 1rem'
  }
}))

export { useInfoBoxStyles }
